<template lang="pug">
	.detail-images
		transition(name="fade")
			img.detail-imageLayout(
				:src="bdrm.ImageURL",
				:key="bdrm.ID",
				:alt="`${bdrm.Title} bedroom image`")
		img.detail-imageBase(
			:src="data.BaseImage",
			:alt="`${data.Title} floorplan image`")
</template>


<script>
export default {
  name: "Images",
  props: ["bdrm", "data"]
};
</script>


<style lang="scss" scoped>
.detail-images {
  position: relative;
  flex: 0 0 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1;
  overflow: hidden;
  @media (min-width: 991px) {
    overflow: visible;
    flex: 0 0 60%;
    max-width: 60%;
  }
  img {
    width: 100%;
    max-width: 660px;
    margin: 0 auto;
  }
}

.detail-imageBase {
  z-index: 1;
}

.detail-imageLayout {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
	opacity: 1;
  &.fade-leave-active {
    transition: opacity 0.5s;
  }
  &.fade-enter-active {
    transition: opacity 0.5s 0.5s;
  }
  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
  }
}
</style>
